<template>
    <div class="search_nav">
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="折扣名称：">
                <el-input v-model="formInline.name" placeholder="折扣名称" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item label="折扣方式：">
                <el-select style="width: 150px;" v-model="formInline.type" placeholder="全部">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="服务费-倍率折扣" value="0"></el-option>
                    <el-option label="服务费-单价减免" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="应用场站：">
                <el-select style="width: 150px;" v-model="formInline.stationId" filterable placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option
                    v-for="item in stationOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="启用状态：">
                <el-select style="width: 120px;" v-model="formInline.state" placeholder="全部">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="已启用" :value="1"></el-option>
                    <el-option label="已停用" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <div class="button_group">
                    <el-button type="primary" @click="getList">搜索</el-button>
                    <el-button type="primary" @click="refresh">刷新</el-button>
                    <el-button type="primary" @click="addDiscount">新增折扣</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>

    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="折扣名称" width="150" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.name || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="折扣方式" width="150">
            <template #default="scope">
                <span>{{ getDiscountTypeDesc(scope.row.type) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="折扣/面额" width="120">
            <template #default="scope">
                <span>{{ checkDiscountAmount(scope.row) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="有效期">
            <template #default="scope">
                <span>{{ formatValidity(scope.row) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="创建时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.createTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="更新时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.updateTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="应用场站" width="150" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.stationNames && scope.row.stationNames.length > 0 ? scope.row.stationNames.join('、') : '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
            <template #default="scope">
                <el-button type="text" @click="editDiscount(scope.row)">修改</el-button>
                <el-button type="text" @click="deleteDiscount(scope.row)">删除</el-button>
            </template>
        </el-table-column>
        <el-table-column label="启用状态" width="100" fixed="right">
            <template #default="scope">
                <el-switch
                    v-model="scope.row.state"
                    :active-value="1"
                    :inactive-value="0"
                    @change="toggleStatus(scope.row)"
                />
            </template>
        </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 新增/编辑折扣弹窗 -->
    <el-dialog v-model="showModal" :title="isEdit ? '修改折扣' : '新增折扣'" :close-on-click-modal="false" width="700px">
        <el-form :model="discountForm" label-width="100px">
            <el-form-item label="折扣名称">
                <el-input v-model="discountForm.name" maxlength="50" placeholder="请输入折扣名称"></el-input>
            </el-form-item>
            <el-form-item label="折扣方式">
                <el-radio-group v-model="discountForm.type">
                    <el-radio :value="0">服务费-倍率折扣</el-radio>
                    <el-radio :value="1">服务费-单价减免</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="discountForm.type == 0" label="折扣倍率">
                <span style="margin-right: 5px;">服务费</span>
                <el-input v-model="discountForm.value" min="0" max="1" step="0.01" type="number" placeholder="≥0且≤1" style="width: 150px;"></el-input>
                <span style="margin-left: 5px;">倍</span>
            </el-form-item>
            <el-form-item v-if="discountForm.type == 1" label="减免金额">
                <span style="margin-right: 5px;">服务费单价减免</span>
                <el-input v-model="discountForm.value" type="number" placeholder="请输入减免金额" style="width: 150px;"></el-input>
                <span style="margin-left: 5px;">元/度</span>
            </el-form-item>
            <el-form-item label="折扣描述">
                <el-input v-model="discountForm.remark" maxlength="100" placeholder="折扣描述"></el-input>
            </el-form-item>
            <el-form-item label="应用场站">
                <el-select v-model="discountForm.stationIds" placeholder="请选择" multiple clearable collapse-tags collapse-tags-tooltip>
                    <el-option
                    v-for="item in stationOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="有效期类型">
                <el-radio-group v-model="discountForm.validity">
                    <el-radio :value="0">永久有效</el-radio>
                    <el-radio :value="1">暂时有效</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="discountForm.validity == 1" label="有效期">
                <el-date-picker
                    v-model="discountForm.dateRange"
                    type="daterange"
                    value-format="YYYY-MM-DD"
                    range-separator="——"
                    start-placeholder="开始时间"
                    end-placeholder="截止时间"
                    style="width: 320px;"
                />
            </el-form-item>
            <el-form-item label="关联用户">
                <el-input
                    v-model="discountForm.userPhone"
                    placeholder="请输入手机号"
                    style="width: 200px;"
                />
                <el-button style="margin-left: 10px;" type="primary" @click="searchUser">搜索</el-button>
                <el-select
                    v-model="discountForm.groupIds"
                    multiple
                    filterable
                    collapse-tags
                    collapse-tags-tooltip
                    :loading="groupLoading"
                    :disabled="groupLoading"
                    placeholder="请选择用户组"
                    style="flex: 1; margin-left: 10px;"
                    @change="handleGroupChange"
                >
                    <el-option
                    v-for="item in userGroupOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-table :data="relatedUsers" :show-header="false" style="width: 100%;">
                    <el-table-column>
                        <template #default="scope">
                            <span style="margin-right: 20px;">用户ID：{{ scope.row.id || '-' }}</span>
                            <span>手机号：{{ scope.row.phoneNumber || '-' }}</span>
                            <el-button type="text" @click="removeUser(scope.row.id)" style="float: right;">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="relatedUsers.length === 0" style="text-align: center; color: #999; padding: 20px;">
                    不可手动输入，展示已关联、用户组成员或搜索关联用户
                </div>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="showModal = false">返回</el-button>
            <el-button type="primary" @click="saveDiscount">保存</el-button>
        </template>
    </el-dialog>
</template>

<script>
export default {
name:'AccountDiscount',
data() {
    return {
        tableData: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        showModal: false,
        isEdit: false,
        stationOptions: [],
        formInline: {
            name: '',
            type: '',
            stationId: '',
            state: ''
        },
        discountForm: {
            id: '',
            name: '',
            type: '',
            value: '',
            remark: '',
            validity: '',
            dateRange: [],
            stationIds: [],
            userPhone: '',
            groupIds: []
        },
        relatedUsers: [],
        userGroupOptions: [],
        groupLoading: false,
        selectedGroupIds: []
    }
},
mounted(){
    this.getList();
    this.getStationOptions();
},
watch: {
    '$store.state.stationList': {
        handler(newVal) {
            if (newVal && newVal.length > 0) {
                this.stationOptions = newVal;
            }
        },
        immediate: true
    }
},
methods:{
    getStationOptions(){
        let that = this;
        that.stationOptions = that.$store.state.stationList || [];
    },
    getList(){
        let that = this;
        let param = {
            page: that.currentPage,
            pageSize: that.pageSize
        };
        Object.keys(this.formInline).forEach(key => {
            if(this.formInline[key]){
                param[key] = this.formInline[key];
            }
        });
        if(param.type === '0'){
            param.type = 0;
        }
        if(param.state === '0'){
            param.state = 0;
        }
        that.$axios.post(that.$store.state.platformApi + "personal/discount/page", JSON.stringify(param)).then(result => {
            if(result.code == 200){
                that.tableData = result.data.records;
                that.total = result.data.total;
            }
        });
    },
    handleSizeChange(val) {
        this.pageSize = val;
        this.getList();
    },
    handleCurrentChange(val) {
        this.currentPage = val;
        this.getList();
    },
    refresh() {
        this.formInline = {
            name: '',
            type: '',
            stationId: '',
            state: ''
        };
        this.currentPage = 1;
        this.getList();
    },
    addDiscount() {
        this.isEdit = false;
        this.relatedUsers = [];
        this.discountForm = {
            id: '',
            name: '',
            type: '',
            value: '',
            remark: '',
            validity: '',
            dateRange: [],
            stationIds: '',
            userPhone: '',
            groupIds: []
        };
        this.selectedGroupIds = [];
        this.getUserGroups();
        this.showModal = true;
    },
    editDiscount(row) {
        this.isEdit = true;
        if(row.users && row.phones && row.users.length === row.phones.length){
            // 合并关联用户列表
            this.relatedUsers = row.users.map((u, index) => ({id: u, phoneNumber: row.phones[index]}));
        } else {
            this.relatedUsers = [];
        }
        this.discountForm = {
            id: row.id,
            state: row.state || 0,
            name: row.name || '',
            type: row.type || 0,
            value: row.value || '',
            remark: row.remark || '',
            validity: row.validity || 0,
            dateRange: row.effectiveStartTime && row.effectiveEndTime ? [row.effectiveStartTime.split(' ')[0], row.effectiveEndTime.split(' ')[0]] : [],
            stationIds: row.stationIds || '',
            userPhone: '',
            groupIds: []
        };
        this.selectedGroupIds = [];
        this.getUserGroups();
        this.showModal = true;
    },
    getUserGroups() {
        let that = this;
        that.$axios.post(that.$store.state.platformApi + "charge/userGroup/list", {}).then(result => {
            if (result.code == 200) {
                that.userGroupOptions = result.data || [];
            }
        });
    },
    handleGroupChange(groupIds) {
        let that = this;
        let prevIds = that.selectedGroupIds;
        // 取消选中的用户组：移除仅来自这些用户组的成员（手动搜索或编辑带入的用户不受影响）
        let removedIds = prevIds.filter(id => groupIds.indexOf(id) == -1);
        if (removedIds.length > 0) {
            that.relatedUsers = that.relatedUsers.filter(u => {
                if (!u.sourceGroupIds || u.sourceGroupIds.length == 0) return true;
                return u.sourceGroupIds.some(g => groupIds.indexOf(g) != -1);
            });
            that.relatedUsers.forEach(u => {
                if (u.sourceGroupIds) {
                    u.sourceGroupIds = u.sourceGroupIds.filter(g => groupIds.indexOf(g) != -1);
                }
            });
        }
        // 新选中的用户组：查询组内成员合并到关联用户列表
        let addedIds = groupIds.filter(id => prevIds.indexOf(id) == -1);
        that.selectedGroupIds = groupIds;
        if (addedIds.length == 0) return;
        that.groupLoading = true;
        let requests = addedIds.map(gid => {
            return that.$axios.post(that.$store.state.platformApi + "charge/userGroup/member/list/" + gid).then(result => {
                if (result.code == 200) {
                    let group = that.userGroupOptions.find(g => g.id == gid);
                    // 接口返回{userId, phoneNumber}
                    return { id: gid, name: group ? group.name : '', members: result.data || [] };
                }
                return { id: gid, name: '', members: null };
            });
        });
        Promise.all(requests).then(results => {
            let emptyGroups = [];
            results.forEach(res => {
                if (!res.members || res.members.length == 0) {
                    emptyGroups.push(res.name);
                    return;
                }
                res.members.forEach(m => {
                    if (!m.phoneNumber) return;
                    let exists = that.relatedUsers.find(u => u.id == m.userId);
                    if (exists) {
                        // 已在列表中的用户只记录来源组，手动搜索添加的用户不标记来源
                        if (exists.sourceGroupIds && exists.sourceGroupIds.indexOf(res.id) == -1) {
                            exists.sourceGroupIds.push(res.id);
                        }
                    } else {
                        that.relatedUsers.push({ id: m.userId, phoneNumber: m.phoneNumber, sourceGroupIds: [res.id] });
                    }
                });
            });
            that.groupLoading = false;
            if (emptyGroups.length > 0) {
                that.$message.warning('用户组[' + emptyGroups.join('、') + ']暂无成员');
            }
        }).catch(() => {
            that.groupLoading = false;
        });
    },
    saveDiscount() {
        let that = this;
        let param = { ...that.discountForm };
        // 将dateRange转换为effectiveStartTime和effectiveEndTime
        if (param.dateRange && param.dateRange.length === 2) {
            param.effectiveStartTime = param.dateRange[0] + ' 00:00:00';
            param.effectiveEndTime = param.dateRange[1] + ' 23:59:59';
        }
        // 添加关联用户列表
        param.users = that.relatedUsers.map(u => u.id);
        param.phones = that.relatedUsers.map(u => u.phoneNumber);
        delete param.dateRange;
        delete param.userPhone;
        delete param.groupIds;
        if(!that.isEdit){
            param.state = 0; // 新增时默认禁用
            delete param.id;
        }
        let url = that.isEdit ? "personal/discount/update" : "personal/discount/add";
        that.$axios.post(that.$store.state.platformApi + url, JSON.stringify(param)).then(result => {
            if(result.code == 200){
                that.$message.success(that.isEdit ? '修改成功' : '新增成功');
                that.showModal = false;
                that.getList();
            }
        });
    },
    searchUser() {
        let that = this;
        if (!that.discountForm.userPhone) {
            that.$message.warning('请输入手机号');
            return;
        }
        let param = [];
        param.push(that.discountForm.userPhone);
        // 模拟搜索用户接口
        that.$axios.post(that.$store.state.platformApi + "personal/discount/users", param).then(result => {
            if(result.code == 200 && result.data.length > 0){
                let user = result.data[0];
                // 检查是否已存在
                let exists = that.relatedUsers.some(u => u.id == user.id);
                if (exists) {
                    that.$message.warning('该用户已关联');
                } else {
                    that.relatedUsers.push(user);
                    that.discountForm.userPhone = '';
                }
            } else {
                that.$message.error('未找到该用户');
            }
        });
    },
    removeUser(userId) {
        this.relatedUsers = this.relatedUsers.filter(u => u.id !== userId);
    },
    deleteDiscount(row) {
        let that = this;
        that.$confirm('确认删除该折扣吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            that.$axios.post(that.$store.state.platformApi + "personal/discount/del/"+row.id, {}).then(result => {
                if(result.code == 200){
                    that.$message.success('删除成功');
                    that.getList();
                }
            });
        });
    },
    toggleStatus(row) {
        let that = this;
        that.$axios.post(that.$store.state.platformApi + "personal/discount/state/"+row.id+"/"+row.state, {}).then(result => {
            if(result.code == 200){
                that.$message.success(row.state == 1 ? '启用成功' : '禁用成功');
            } else {
                row.state = row.state == 1 ? 0 : 1;
            }
        });
    },
    getDiscountTypeDesc(type){
        switch(type){
            case 0:
                return '服务费-倍率折扣';
            case 1:
                return '服务费-单价减免';
            default:
                return '-';
        }
    },
    checkDiscountAmount(row){
        if(!row) return '-';
        if(row.type == 0){
            return (row.value || '-') + '倍';
        } else if(row.type == 1){
            return (row.value || '-') + '元';
        } else {
            return '-';
        }
    },
    formatValidity(row){
        if(!row) return '-';
        if(row.validity == 0){
            return '永久';
        } else if(row.validity == 1){
            return (row.effectiveStartTime || '') + '至' + (row.effectiveEndTime || '');
        } else {
            return '-';
        }
    }
}
}
</script>

<style lang="scss" scoped>
.search_nav{
    padding: 15px;
    background: #fff;
    margin-bottom: 15px;
}
.button_group{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    button{
        margin-left: 10px;
    }
}
</style>